import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { IPolicySummary, IStrapiDocument } from 'src/app/interfaces/strapi';
import StrapiService from 'src/app/services/strapi.service';
import { NgFor, NgIf } from '@angular/common';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';

@Component({
    selector: 'app-policy-summary',
    templateUrl: './policy-summary.component.html',
    styleUrls: ['./policy-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        BreadcrumbsComponent,
        NgFor,
        NgIf,
    ],
})
export class PolicySummaryComponent implements OnInit {
  public policySummaryData = signal<IPolicySummary>(<IPolicySummary>{});

  constructor(private readonly strapi: StrapiService) {}

  public ngOnInit(): void {
    this.strapi.getPolicySummary().subscribe({
      next: (policySummary: IStrapiDocument<IPolicySummary>) => {
        this.policySummaryData.set(policySummary.data?.attributes);
      },
    });
  }
}
